/**
 * テーマオプション/スライダー
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.BACKYARD_ENDPOINT}/theme_option/banners`

const theme_option_banner_link = {
    namespaced: true,
    state: {},
    getters: {},
    actions: {
        index ({ _commit }, {id}) {
            const api_path = `${API_PATH}/${id}/banner_links`
            return new Promise((resolve, _reject) => {
                Vue.$http.get(api_path).then(data => {
                    resolve(data.content)
                })
            })
        },
    },
    mutations: {},
}

export default theme_option_banner_link